import { render, staticRenderFns } from "./hooks.vue?vue&type=template&id=7e0c5b77&lang=html&"
import script from "./hooks.vue?vue&type=script&lang=js&"
export * from "./hooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "hooks.vue"
export default component.exports